module.exports = __webpack_public_path__ + "static/media/centerfSD_logo.6963e0ce.svg";